import React, { useState } from 'react';
import overlay from './img/2.png';

const TapalkaPage = () => {
  const [waterLevel, setWaterLevel] = useState(0);
  const [drops, setDrops] = useState([]);

  const handleTap = () => {
    if (waterLevel >= 100) return;
    const id = Date.now();
    setDrops(prev => [...prev, id]);
    setWaterLevel(prev => Math.min(prev + 10, 100));
    setTimeout(() => {
      setDrops(prev => prev.filter(dropId => dropId !== id));
    }, 1000);
  };

  return (
    <div className="container">
      <h1>Кран и бутылка 19L</h1>

      <div className="faucet" onClick={handleTap}>
        <div className="faucet-body" />
        <div className="spout" />
        {drops.map(id => (
          <div key={id} className="drop" />
        ))}
      </div>

      {/* Блок заливки и наложение рисунка */}
      <div className="bottle-container">
        <div
          className="water"
          style={{ height: `${waterLevel}%` }}
        />
        {/* Наложенная картинка с отверстием */}
        <img src={overlay} alt="overlay" className="overlay" />
      </div>

      <p>Уровень воды: {waterLevel}%</p>

      <style>{`
        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 40px;
          font-family: sans-serif;
        }
        .faucet {
          position: relative;
          width: 200px;
          height: 80px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        .faucet-body {
          position: absolute;
          top: 0;
          left: 50%;
          width: 120px;
          height: 30px;
          background: #bbb;
          border-radius: 8px;
          transform: translateX(-50%);
        }
        .spout {
          position: absolute;
          top: 30px;
          left: 50%;
          width: 20px;
          height: 80px;
          background: #999;
          border-radius: 10px;
          transform: translateX(-50%);
        }
        .drop {
          position: absolute;
          top: 110px;
          left: calc(50% - 7px);
          width: 14px;
          height: 14px;
          background: #007BFF;
          border-radius: 50%;
          animation: drip 1s linear;
        }
        @keyframes drip {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(220px); opacity: 0; }
        }
        .bottle-container {
          position: relative;
          width: 250px;
          height: 250px;
          margin-bottom: 20px;
          overflow: hidden;
        }
        .water {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: rgba(0,123,255,0.4);
          transition: height 0.5s ease;
        }
        .water::before, .water::after {
          content: '';
          position: absolute;
          width: 200%;
          height: 20px;
          background: #007BFF;
          opacity: 0.6;
          top: -10px;
          border-radius: 100%;
          animation: wave 4s infinite linear;
        }
        .water::after {
          opacity: 0.4;
          animation-delay: -2s;
        }
        @keyframes wave {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          /* Задаём масштаб по ширине, сохраняя пропорции */
          width: 100%;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
};

export default TapalkaPage;
